// Not ported (dead in the Angular app): getDepreciationCalculation, saveDisposals, createDepreciationJournal
import { api } from '@/core/http/apiClient';
import type {
  DepreciationPolicyView,
  FixedAssetSyncResponse,
  FixedAssetSyncView,
  SaveDepreciationPoliciesPayload,
} from '@/core/models/phase7.models';

const base = 'FixedAssetRegister';

export const fixedAssetService = {
  getSync: (periodId: string) => api.get<FixedAssetSyncView>(`${base}/getSync/${periodId}`),

  syncPeriod: (periodId: string) => api.post<FixedAssetSyncResponse>(`${base}/syncPeriod/${periodId}`, {}),

  clearStale: (periodId: string, staleObjectId: string) =>
    api.post<FixedAssetSyncView>(`${base}/clearStale/${periodId}/${staleObjectId}`, {}),

  getDepreciationPolicies: (clientId: string) =>
    api.get<DepreciationPolicyView>(`${base}/getDepreciationPolicies/${clientId}`),

  saveDepreciationPolicies: (payload: SaveDepreciationPoliciesPayload) =>
    api.post<DepreciationPolicyView>(`${base}/saveDepreciationPolicies`, payload),
};
